import FeatureLayer from "@arcgis/core/layers/FeatureLayer";

export const gt95rcp4530 = new FeatureLayer({
    url: "https://njmaps1.rad.rutgers.edu/arcgis/rest/services/Climate/ZZ_TempGT95/MapServer/8",
    title: 'Number of Days above 95 Change until 2030',
    opacity: 0.4,
    oraId: 'gt95rcp4530',
  })